import React, { useState, useEffect } from 'react';
import CButton from '../../../../../Assets/Components/CButton';
import QuestionTabComponent from '../../Component/Tabs/QuestionTabComponent';
import { toastr } from 'react-redux-toastr';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from '@tanstack/react-query';
import { contentManagementContentQuestionAPI } from '../../../../../Services/ElearningContentManagement/contentQuestion';
import { Switch } from 'antd';
import QuestionModalContainer from '../Modal/QuestionModalContainer';
import ErrorHandler from '../../../../../App/ErrorHandler';

interface IProps {
  currentTab: string;
  stage: any;
  submodule: any;
}

export default function QuestionTabContainer(props: IProps) {
  const { currentTab, submodule } = props;
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState();
  const [selectedStatus, setSelectedStatus] = useState();
  const [selectedData, setSelectedData] = useState();

  useEffect(() => {
    if (submodule) return;
    setSelectedStatus(undefined);
    setFilter(undefined);
  }, [submodule]);

  useEffect(() => {
    if (currentTab !== 'Question') return;
    setSelectedStatus(undefined);
    setFilter(undefined);
  }, [currentTab]);

  const {
    data: dataQuestion,
    isLoading: isLoadingQuestion,
    isRefetching: isRefetchQuestion,
    refetch,
  } = useQuery(
    ['getContentManagementQuestionAPI', { id: submodule?.id }],
    contentManagementContentQuestionAPI.getQuestion,
    {
      enabled: submodule?.id !== undefined,
      refetchOnWindowFocus: false,
    }
  );

  const mutateDelete = useMutation(
    contentManagementContentQuestionAPI.deleteQuestion,
    {
      onError: (error: any) => {
        ErrorHandler(error);
      },
      onSuccess: () => {
        toast.success(
          <span className="capitalFirst">Question Berhasil Dihapus</span>
        );
        refetch();
      },
    }
  );

  const mutateQuestionStatus = useMutation(
    contentManagementContentQuestionAPI.mutateQuestionStatus,
    {
      onSuccess: () => {
        setShowModal(false);
        refetch();
        toast.success(
          <span className="capitalFirst">Question Berhasil Diupdate!</span>
        );
      },
      onError: (error: any) => {
        ErrorHandler(error);
      },
    }
  );

  const processStatusChannel = (id: number, status?: boolean) => {
    mutateQuestionStatus.mutate({ status, id });
  };
  const processEnabledStatus = (id: number, status: boolean, row: any) => {
    const rowData = row.row.original;
    const action = status === true ? 'mengaktifkan' : 'menon-aktifkan';
    const actionConfirm = status === true ? 'Aktifkan' : 'Non-Aktifkan';
    const toastrConfirmOptions = {
      okText: actionConfirm,
      cancelText: 'Batalkan',
      onOk: () => processStatusChannel(id, status),
      id: 'toastRConfirm',
    };
    toastr.confirm(
      `Anda yakin ingin ${action} Question "${rowData.title}"?`,
      toastrConfirmOptions
    );
  };

  const renderStatus = row => {
    const rowData = row.row.original;
    const processEnabled = isChecked =>
      processEnabledStatus(rowData.id, isChecked, row);
    return (
      <Switch
        onChange={processEnabled}
        checked={rowData.isActive}
        id={rowData.id}
      />
    );
  };

  const renderAction = row => {
    const rowData = row.row.original;
    const handleEdit = () => {
      setSelectedData(rowData);
      setShowModal(true);
    };
    const handleDelete = () => {
      const toastrConfirmOptions = {
        okText: 'Delete',
        cancelText: 'Batalkan',
        onOk: () => mutateDelete.mutate(rowData.id),
        id: 'toastConfirmQuestionContent',
      };
      toastr.confirm(
        `Delete Question content "${rowData.title}"`,
        toastrConfirmOptions
      );
    };
    const dataButton = [
      {
        id: `btnDeleteContentQuestion`,
        type: 'danger',
        icon: 'DeleteOutlined',
        className: 'buttonTable',
        onClick: handleDelete,
      },
      {
        id: `btnEditContentQuestion`,
        type: 'primary',
        icon: 'EditOutlined',
        onClick: handleEdit,
        className: 'buttonTable',
      },
    ];
    return <CButton buttonData={dataButton} />;
  };

  const renderTitleQuestion = row => {
    return <p className="titleQuestion">{row.row.original.title}</p>;
  };

  const columnData = [
    {
      Header: 'Question title',
      accessor: 'title',
      Cell: row => renderTitleQuestion(row),
    },
    {
      Header: 'Point',
      accessor: 'point',
    },
    {
      Header: 'Status',
      Cell: row => renderStatus(row),
    },
    {
      Header: 'Action',
      Cell: row => renderAction(row),
    },
  ];

  const handleApplyfilter = () => setFilter(selectedStatus);
  const handleAdd = () => setShowModal(true);
  const handleRefresh = () => {
    refetch();
    setSelectedStatus(undefined);
    setFilter(undefined);
  };

  const data = dataQuestion
    ? filter === 'active'
      ? dataQuestion.filter(item => item.isActive)
      : filter === 'inactive'
      ? dataQuestion.filter(item => !item.isActive)
      : dataQuestion
    : [];

  return (
    <>
      <QuestionTabComponent
        columnData={columnData}
        disabled={submodule && submodule.type === null ? true : false}
        selectedStatus={selectedStatus}
        dataQuestion={data}
        handleRefresh={handleRefresh}
        handleAdd={handleAdd}
        isLoading={
          isLoadingQuestion ||
          isRefetchQuestion ||
          mutateDelete.isLoading ||
          mutateQuestionStatus.isLoading
        }
        setSelectedStatus={setSelectedStatus}
        handleApplyfilter={handleApplyfilter}
      />
      <QuestionModalContainer
        {...props}
        showModal={showModal}
        setShowModal={setShowModal}
        selectedData={selectedData}
        setSelectedData={setSelectedData}
        handleRefresh={handleRefresh}
      />
    </>
  );
}
